import React, {Component} from 'react'

export default class ListLogRowComponent extends Component {
	render() {
		return (
			<tr>
				<td>{ this.props.log.dateCreated }</td>
				<td>{ this.props.log.action }</td>
				<td><div dangerouslySetInnerHTML={{ __html: this.props.log.description }} /></td>
				<td>{ this.props.log.service }</td>
			</tr>
		)
	}
}